import React from "react";
import axios from "axios";

import "./App.css";

function App() {
  //date
  function formatDate(now) {
    let hours = now.getHours();
    if (hours < 10) {
      hours = `0${hours}`;
    }
    let minutes = now.getMinutes();
    if (minutes < 10) {
      minutes = `0${minutes}`;
    }
    let dayIndex = now.getDay();
    let days = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];

    let day = days[dayIndex];
    return `${day}, <br/> ${hours}:${minutes}`;
  }

  let dateElement = document.querySelector("#time");
  let currentTime = new Date();
  dateElement.innerHTML = formatDate(currentTime);

  //Forecast prediction (coordinates)
  function getForecast(coordinates) {
    console.log(coordinates);
    let key = "cb286bad3607984b41ed10c8de5cf00e";
    let url = `https://api.openweathermap.org/data/2.5/onecall?lat=${coordinates.lat}&lon=${coordinates.lon}&appid=${key}&units=metric`;
    axios.get(url).then(displayForecast);
  }

  //city, icon, temperature
  function weather(response) {
    document.querySelector("#city").innerHTML = response.data.name;

    let iconElement = document.querySelector("#icon");
    iconElement.setAttribute(
      "src",
      `http://openweathermap.org/img/wn/${response.data.weather[0].icon}@2x.png`
    );
    iconElement.setAttribute("alt", response.data.weather[0].description);
    celsiusTemperature = response.data.main.temp;

    document.querySelector("#temperature").innerHTML = `${Math.round(
      (celsiusTemperature = response.data.main.temp)
    )}`;
    getForecast(response.data.coord);
  }
  //search city
  function search(event) {
    event.preventDefault();
    let cityInput = document.querySelector("#city-input");
    let city = cityInput.value;
    searchCity(city);
  }

  function searchCity(city) {
    let key = "cb286bad3607984b41ed10c8de5cf00e";
    let url = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${key}&units=metric`;
    axios.get(url).then(weather);
  }
  let form = document.querySelector("#search-form");
  form.addEventListener("submit", search);
  searchCity("kyiv");
  //unit
  function displayFahrenheitTemperature(event) {
    event.preventDefault();
    let temperatureElement = document.querySelector("#temperature");
    let fahrenheiTemperature = (celsiusTemperature * 9) / 5 + 32;
    temperatureElement.innerHTML = Math.round(fahrenheiTemperature);
  }

  function displayCelsiusTemperature(event) {
    event.preventDefault();
    let temperatureElement = document.querySelector("#temperature");
    temperatureElement.innerHTML = Math.round(celsiusTemperature);
  }
  let celsiusTemperature = null;

  let fahrenheitLink = document.querySelector("#fahrenheit-link");
  fahrenheitLink.addEventListener("click", displayFahrenheitTemperature);

  let celsiusLink = document.querySelector("#celsius-link");
  celsiusLink.addEventListener("click", displayCelsiusTemperature);

  //Format day
  function formatDay(timestamp) {
    let date = new Date(timestamp * 1000);
    let day = date.getDay();
    let days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    return days[day];
  }

  //Column repeat
  function displayForecast(response) {
    let forecast = response.data.daily;
    let forecastElement = document.querySelector("#forecast");
    let forecastHTML = `<div class="row">`;
    forecast.forEach(function (forecastDay, index) {
      if (index < 6) {
        forecastHTML =
          forecastHTML +
          `<div class="border + col">
          <div class="weather-forecast-day">${formatDay(forecastDay.dt)}</div>
          <img src="http://openweathermap.org/img/wn/${
            forecastDay.weather[0].icon
          }@2x.png" alt=""
          width="42" />
           <div class="weather-forecast-temperatures">
           <span class="weather-forecast-temperature">${Math.round(
             forecastDay.temp.day
           )}°</span>
           </div>
        </div>`;
      }
    });
    forecastHTML = forecastHTML + `</div>`;
    forecastElement.innerHTML = forecastHTML;
  }
  return <div className="App"></div>;
}

export default App;
